/* VSKLO collection filters — canonical cached runtime extracted from collection-sidebar.liquid. */
(function () {
      'use strict';

      if (window.__VSKLO_FILTER_FAST_V8__) return;
      window.__VSKLO_FILTER_FAST_V8__ = true;

      var priceTimer = null;
      var ajaxTimer = null;
      var currentController = null;
      var fullRangeController = null;
      var fullRangeRequestId = 0;
      var activeTrackDrag = null;
      var desiredUrl = new URL(window.location.href);
      var confirmedUrl = desiredUrl.toString();
      var desiredVersion = 0;
      var touchedPriceBoxes = new WeakSet();
      var fullRangeCache = window.__vskloFullPriceRangeCache || (window.__vskloFullPriceRangeCache = new Map());

      // VSKLO_FILTER_POPULARITY_ORDER
      // Stable global facet ranking from the full catalog coverage snapshot (2026-09-20).
      // We intentionally do not sort by the live count after every click, because that would
      // make options jump around while the customer is filtering.
      function normalizeFacetText(value) {
        return String(value || '')
          .replace(/[ʼ’']/g, "'")
          .replace(/\u00a0/g, ' ')
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();
      }

      var VSKLO_FILTER_POPULARITY_ORDER = {
        purpose: "Для віскі|Для горілки|Для вина|Для пива|Для напоїв|Для міцних напоїв|Для коктейлів|Для коньяку|Для шампанського|Подарунковий сертифікат".split('|'),
        insert: "Куля|Герб|Куля + Герб|Куля/Герб/Колосок|Вишня|Біткоїн|ДПСУ|СБУ|MIX|ЗСУ|Поліція|Дрон|Лимонка|Мандарин|Кубик|Блешня|Полуниця|Гарбуз|Колосок|Mercedes|Якір|Audi|BMW|Яблуко|Груша|Гранат|М’яч|Перець|Без вставки|Болт + Баранець|Національна гвардія|Обручка з позолотою|Обручки з позолотою|Свічка|Три кулі|Футбол|Автомобільний логотип|ДМСУ|Медіатор|Фрутекс|Шприц + Градусник|Більярд|Гранат + Вишня|Долар|Долар зелений|Золотий дрон|Літачок|Полуниця + Вишня|Lexus|MONEY|Tesla|Toyota|Volkswagen|Вишня + Мандарин|Груша + Яблуко|Куля + Лимонка|Куля збоку|Огірок|Служби України|Сокира|Євро|Євро золотий|Audi + Mercedes|BMW + Mercedes|Citroën|Ford|Honda|Hyundai|Infiniti|Iveco|Kia|Mazda|Mitsubishi|Nissan|Opel|Peugeot|Renault|Škoda|Subaru|Suzuki|Volvo|АК-47|Баскетбольний м’яч|Близнюки|Вишня + Полуниця + Гранат|Водолій|Діва|Козеріг|Лев|Металевий диск|Овен|Полуниця + Гранат|Рак|Риби|Скорпіон|Стрілець|Телець|Терези|Тетраедр|Три кулі + Лимонка|Шприц + Градусник + Кадуцей".split('|'),
        theme: "Патріотичні та Військові|Патріотична|Фруктова|Для служб України|Авто|Фінансова|Інше|Спорт|Рибалка|Морська|Знаки зодіаку|Овочева|Медицина|Музична|Весільна|Сертифікат|Авіація".split('|'),
        set: "Одиничні вироби|6 чарок|2 склянки|4 склянки|6 склянок|2 склянки та графин|графин|6 чарок та графин|2 пивні келихи|2 келихи для вина|4 склянки та графин|2 чашки|6 келихів для вина|6 склянок та графин|4 коктейльні келихи|4 келихи для вина|2 келихи для коньяку|2 коктейльні келихи|6 келихів для шампанського|2 келихи для шампанського|12 чарок та графин|5 склянок та графин|подарунковий сертифікат|4 пивні келихи|1 виріб|4 келихи для коньяку".split('|'),
        recipient: "Для чоловіків|Для жінок|Для пари|Універсальні".split('|')
      };

      var VSKLO_FILTER_GROUP_ALIASES = {
        "тип товару": "purpose",
        "тип продукту": "purpose",
        "призначення": "purpose",
        "product type": "purpose",
        "purpose": "purpose",
        "вставка": "insert",
        "insert": "insert",
        "тематика": "theme",
        "theme": "theme",
        "склад набору": "set",
        "кількість предметів": "set",
        "вироби в наборі": "set",
        "комплектація": "set",
        "items in the set": "set",
        "set contents": "set",
        "для кого": "recipient",
        "for whom": "recipient",
        "recipient": "recipient"
      };

      var VSKLO_FILTER_POPULARITY_RANKS = {};
      Object.keys(VSKLO_FILTER_POPULARITY_ORDER).forEach(function (groupKey) {
        var rank = Object.create(null);
        VSKLO_FILTER_POPULARITY_ORDER[groupKey].forEach(function (value, index) {
          rank[normalizeFacetText(value)] = index;
        });
        VSKLO_FILTER_POPULARITY_RANKS[groupKey] = rank;
      });

      function sortFacetValuesByPopularity(root) {
        root = root || document;

        root
          .querySelectorAll('#CollectionSidebar collapsible-block[data-vsklo-filter-label]')
          .forEach(function (block) {
            var rawLabel = normalizeFacetText(block.getAttribute('data-vsklo-filter-label'));
            var groupKey = VSKLO_FILTER_GROUP_ALIASES[rawLabel];
            var rank = groupKey && VSKLO_FILTER_POPULARITY_RANKS[groupKey];
            if (!rank) return;

            block.querySelectorAll('.collapsible-content ul.items').forEach(function (list) {
              var items = Array.prototype.slice
                .call(list.children)
                .filter(function (item) {
                  return item.matches('li.item[data-vsklo-filter-value]');
                });

              if (items.length < 2) return;

              var ordered = items.map(function (item, originalIndex) {
                var key = normalizeFacetText(item.getAttribute('data-vsklo-filter-value'));
                var known = Object.prototype.hasOwnProperty.call(rank, key);
                return {
                  item: item,
                  originalIndex: originalIndex,
                  rank: known ? rank[key] : Number.MAX_SAFE_INTEGER
                };
              });

              ordered.sort(function (a, b) {
                if (a.rank !== b.rank) return a.rank - b.rank;
                return a.originalIndex - b.originalIndex;
              });

              // Do not detach every unchanged facet on each AJAX response.
              // A touchstart/touchend can straddle that DOM move and lose its click.
              ordered.forEach(function (entry, index) {
                if (list.children[index] !== entry.item) {
                  list.insertBefore(entry.item, list.children[index] || null);
                }
              });
            });
          });
      }

      // VSKLO: не використовуємо sessionStorage для закритих вкладок.
      // Так перша вкладка стартує відкритою після оновлення сторінки,
      // але в межах поточного відкриття сторінки користувач може її закрити.
      var closedFilterBlocks = {};

      function getClosedMap() {
        return closedFilterBlocks || {};
      }

      function setClosedMap(map) {
        closedFilterBlocks = map || {};
      }

      function getBlockKey(block) {
        var heading = block && block.querySelector('.collapsible-heading');
        var text = heading ? heading.textContent : '';
        return text
          .replace(/[+−–—]/g, '')
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();
      }

      // Accessible facet headings follow the existing in-place accordion state.
      // Keep the original custom element and AJAX reconciliation untouched.
      function syncFacetAccordionA11y(root) {
        (root || document).querySelectorAll('#CollectionSidebar .filter-blocks collapsible-block')
          .forEach(function (block, index) {
            var heading = block.querySelector('.collapsible-heading');
            var content = block.querySelector('.collapsible-content');
            if (!heading || !content) return;
            if (!content.id) content.id = 'vsklo-facet-content-' + (index + 1);
            heading.setAttribute('role', 'button');
            heading.setAttribute('tabindex', '0');
            heading.setAttribute('aria-controls', content.id);
            heading.setAttribute(
              'aria-expanded',
              block.classList.contains('active') && getComputedStyle(content).display !== 'none' ? 'true' : 'false'
            );
          });
      }

      function setBlockState(block, open, save) {
        if (!block) return;
        var content = block.querySelector('.collapsible-content');
        if (!content) return;
        // Animate only direct user toggles; initial state and AJAX reconciliation
        // must stay immediate to preserve scroll, facet selections and speed.
        var previous = content._vskloFacetMotion;
        var currentHeight = content.getBoundingClientRect().height;
        var currentOpacity = parseFloat(getComputedStyle(content).opacity) || 0;
        if (previous) {
          previous.onfinish = null;
          previous.cancel();
          delete content._vskloFacetMotion;
        }
        content.style.removeProperty('overflow');
        content.style.removeProperty('visibility');
        var wasOpen = block.classList.contains('active') &&
          getComputedStyle(content).display !== 'none';
        var animate = Boolean(save && wasOpen !== !!open && typeof content.animate === 'function' &&
          !window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches);
        block.classList.toggle('active', !!open);
        content.style.setProperty('display', (open || animate) ? 'block' : 'none', 'important');
        var heading = block.querySelector('.collapsible-heading');
        if (heading) heading.setAttribute('aria-expanded', open ? 'true' : 'false');

        if (animate) {
          var endHeight = open ? content.scrollHeight : 0;
          var startHeight = previous ? currentHeight : (open ? 0 : currentHeight);
          content.style.setProperty('overflow', 'hidden', 'important');
          if (!open) content.style.setProperty('visibility', 'visible', 'important');
          var motion = content.animate(
            [
              { height: startHeight + 'px', opacity: previous ? currentOpacity : (open ? 0 : 1) },
              { height: endHeight + 'px', opacity: open ? 1 : 0 }
            ],
            { duration: open ? 260 : 220, easing: 'cubic-bezier(.22,.61,.36,1)' }
          );
          content._vskloFacetMotion = motion;
          motion.onfinish = function () {
            if (content._vskloFacetMotion !== motion) return;
            delete content._vskloFacetMotion;
            if (!open) content.style.setProperty('display', 'none', 'important');
            content.style.removeProperty('overflow');
            content.style.removeProperty('visibility');
          };
        }

        if (save) {
          var key = getBlockKey(block);
          if (key) {
            var map = getClosedMap();
            if (open) delete map[key];
            else map[key] = true;
            setClosedMap(map);
          }
        }
      }

      function isDefaultOpenFilterBlock(block) {
        if (!block || block.classList.contains('vsklo-recommended-products')) return false;
        if (block.classList.contains('vsklo-price-filter')) return true;
        if (block.classList.contains('vsklo-product-type-filter')) return true;

        var key = getBlockKey(block);
        return (
          key.indexOf('ціна') > -1 ||
          key.indexOf('price') > -1 ||
          key.indexOf('тип товару') > -1 ||
          key.indexOf('product type') > -1 ||
          key.indexOf('type product') > -1
        );
      }

      function forceDefaultOpenFilters(root) {
        root = root || document;
        var map = getClosedMap();

        root
          .querySelectorAll(
            '#CollectionSidebar .filter-blocks collapsible-block.vsklo-filter-accordion:not(.vsklo-recommended-products)'
          )
          .forEach(function (block) {
            if (!isDefaultOpenFilterBlock(block)) return;

            var key = getBlockKey(block);

            // Якщо користувач вже закрив цю вкладку під час поточного відкриття сторінки — не відкриваємо її назад.
            if (key && map[key]) return;

            setBlockState(block, true, false);
          });
      }

      function applySavedClosedStates(root) {
        root = root || document;
        var map = getClosedMap();

        root.querySelectorAll('#CollectionSidebar collapsible-block').forEach(function (block) {
          var key = getBlockKey(block);
          if (key && map[key]) setBlockState(block, false, false);
        });
      }

      function cleanNumber(value) {
        var text = String(value || '')
          .replace(/\s+/g, '')
          .replace(/[^\d.,]/g, '');
        if (!text) return 0;

        var lastComma = text.lastIndexOf(',');
        var lastDot = text.lastIndexOf('.');
        var decimalPos = Math.max(lastComma, lastDot);
        var normalized;

        if (decimalPos > -1 && text.length - decimalPos - 1 === 2) {
          normalized =
            text.slice(0, decimalPos).replace(/[^\d]/g, '') +
            '.' +
            text.slice(decimalPos + 1).replace(/[^\d]/g, '');
        } else {
          normalized = text.replace(/[^\d]/g, '');
        }

        var num = parseFloat(normalized);
        return isFinite(num) ? Math.round(num) : 0;
      }

      function clamp(value, min, max) {
        return Math.max(min, Math.min(value, max));
      }

      function formatPlain(value) {
        return String(Math.max(0, Math.round(value || 0)));
      }

      function formatLabel(value) {
        var locale = document.documentElement.lang || undefined;
        var currency =
          (window.VSKLO_STOREFRONT && window.VSKLO_STOREFRONT.currency) ||
          (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
          window.vskloPresentmentCurrency ||
          '';
        var amount = Math.max(0, Math.round(value || 0));

        if (currency && window.Intl && Intl.NumberFormat) {
          try {
            return new Intl.NumberFormat(locale, {
              style: 'currency',
              currency: currency,
              currencyDisplay: 'narrowSymbol',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }).format(amount);
          } catch (error) {}
        }

        return currency ? formatPlain(amount) + ' ' + currency : formatPlain(amount);
      }

      function getPriceBox(el) {
        return el ? el.closest('.vsklo-price-filter') : null;
      }

      function getPriceInputs(box) {
        if (!box) return null;

        var minInput = box.querySelector('.min-price-range');
        var maxInput = box.querySelector('.max-price-range');
        var minRange = box.querySelector('.range-slider-min');
        var maxRange = box.querySelector('.range-slider-max');

        if (!minInput || !maxInput || !minRange || !maxRange) return null;

        return {
          minInput: minInput,
          maxInput: maxInput,
          minRange: minRange,
          maxRange: maxRange,
        };
      }

      function getCurrentUrl() {
        return new URL(window.location.href);
      }

      function hasActivePriceParams(parts) {
        if (!parts) return false;
        var url = getCurrentUrl();
        return url.searchParams.has(parts.minInput.name) || url.searchParams.has(parts.maxInput.name);
      }

      function markPriceTouched(box) {
        if (box) touchedPriceBoxes.add(box);
      }

      function getBounds(parts) {
        var lower = cleanNumber(parts.minRange.min || parts.minInput.min || 0);
        var upper = cleanNumber(parts.maxRange.max || parts.maxInput.max || parts.maxInput.value || 0);

        lower = Math.max(0, lower);
        if (!isFinite(upper) || upper <= lower) upper = lower + 1;

        return { lower: lower, upper: upper };
      }

      function setActiveThumb(parts, owner) {
        if (!parts) return;
        parts.minRange.style.setProperty('z-index', owner === 'min' ? '5' : '2', 'important');
        parts.maxRange.style.setProperty('z-index', owner === 'max' ? '5' : '3', 'important');
      }

      function updatePriceView(box, source) {
        var parts = getPriceInputs(box);
        if (!parts) return null;

        var bounds = getBounds(parts);
        var lower = bounds.lower;
        var upper = bounds.upper;

        var min =
          source === 'text-min'
            ? (String(parts.minInput.value || '').trim() ? cleanNumber(parts.minInput.value) : lower)
            : cleanNumber(parts.minRange.value);

        var max =
          source === 'text-max'
            ? (String(parts.maxInput.value || '').trim() ? cleanNumber(parts.maxInput.value) : upper)
            : cleanNumber(parts.maxRange.value);

        min = clamp(min, lower, upper);
        max = clamp(max, lower, upper);

        // The thumb being moved stops at the other thumb.
        // It never pushes the opposite value along with it.
        if (min > max) {
          if (source === 'min' || source === 'text-min') min = max;
          else if (source === 'max' || source === 'text-max') max = min;
          else min = max;
        }

        parts.minRange.value = String(min);
        parts.maxRange.value = String(max);
        parts.minInput.value = formatPlain(min);
        parts.maxInput.value = formatPlain(max);

        if (source === 'min' || source === 'text-min') setActiveThumb(parts, 'min');
        if (source === 'max' || source === 'text-max') setActiveThumb(parts, 'max');

        var minText = box.querySelector('.price-lable .min');
        var maxText = box.querySelector('.price-lable .max');
        var dropRange = box.querySelector('.drop-range');

        if (minText) minText.textContent = formatLabel(min);
        if (maxText) maxText.textContent = formatLabel(max);

        if (dropRange && upper > lower) {
          var span = upper - lower;
          var from = clamp(((min - lower) / span) * 100, 0, 100);
          var to = clamp(((max - lower) / span) * 100, 0, 100);
          dropRange.style.setProperty('--range-from', from + '%');
          dropRange.style.setProperty('--range-to', to + '%');
        } else if (dropRange) {
          dropRange.style.setProperty('--range-from', '0%');
          dropRange.style.setProperty('--range-to', '100%');
        }

        return {
          min: min,
          max: max,
          lower: lower,
          upper: upper,
        };
      }

      function setPriceBounds(box, lower, upper, preserveSelection) {
        var parts = getPriceInputs(box);
        if (!parts || !isFinite(lower) || !isFinite(upper)) return false;

        lower = Math.max(0, Math.round(lower));
        upper = Math.round(upper);

        // A one-price collection still needs a usable native range.
        if (upper <= lower) lower = Math.max(0, upper - 1);
        if (upper <= lower) upper = lower + 1;

        var url = getCurrentUrl();
        var activePrice = hasActivePriceParams(parts);

        var selectedMin = cleanNumber(
          url.searchParams.get(parts.minInput.name) || parts.minRange.value || parts.minInput.value || lower
        );
        var selectedMax = cleanNumber(
          url.searchParams.get(parts.maxInput.name) || parts.maxRange.value || parts.maxInput.value || upper
        );

        parts.minRange.min = String(lower);
        parts.maxRange.min = String(lower);
        parts.minInput.min = String(lower);
        parts.maxInput.min = String(lower);

        parts.minRange.max = String(upper);
        parts.maxRange.max = String(upper);
        parts.minInput.max = String(upper);
        parts.maxInput.max = String(upper);

        if (!activePrice && !preserveSelection) {
          selectedMin = lower;
          selectedMax = upper;
        } else {
          selectedMin = clamp(selectedMin || lower, lower, upper);
          selectedMax = clamp(selectedMax || upper, lower, upper);
        }

        if (selectedMin > selectedMax) selectedMin = selectedMax;

        parts.minRange.value = String(selectedMin);
        parts.maxRange.value = String(selectedMax);
        parts.minInput.value = formatPlain(selectedMin);
        parts.maxInput.value = formatPlain(selectedMax);

        updatePriceView(box, 'bounds');
        return true;
      }

      function parsePriceFromText(text) {
        var value = cleanNumber(text);
        if (!value || value < 1 || value > 10000000) return null;
        return value;
      }

      function getProductRoot(doc) {
        return doc.querySelector('#product-grid') || doc.querySelector('#productgridcontainer') || doc;
      }

      function getProductCards(root) {
        if (!root) return [];

        return Array.prototype.slice
          .call(root.querySelectorAll('.product-item, .grid__item, [data-product-id], [data-product-handle]'))
          .filter(function (card) {
            return !!card.querySelector('a[href*="/products/"]') ||
              !!card.getAttribute('data-product-id') ||
              !!card.getAttribute('data-product-handle');
          });
      }

      function getPriceFromCard(card) {
        if (!card) return null;

        var dataPrice = card.querySelector('[data-price]');
        if (dataPrice) {
          var raw = cleanNumber(dataPrice.getAttribute('data-price'));
          if (raw > 100000) raw = Math.round(raw / 100);
          if (raw > 0) return raw;
        }

        var selectors = [
          '.product-item__price .price-item--sale',
          '.product-item__price .price-item--regular',
          '.product-item__price',
          '.bls__product-price .price-item--sale',
          '.bls__product-price .price-item--regular',
          '.bls__product-price',
          '.card-information .price .price-item--sale',
          '.card-information .price .price-item--regular',
          '.card-information .price',
          '.price .price-item--sale',
          '.price .price-item--regular',
          '.price',
        ];

        for (var i = 0; i < selectors.length; i += 1) {
          var node = card.querySelector(selectors[i]);
          if (!node) continue;

          var matches = (node.textContent || '').match(/[₴€$]?\s*\d[\d\s.,]*/g) || [];
          var values = matches
            .map(parsePriceFromText)
            .filter(function (value) {
              return value !== null;
            });

          if (values.length) return Math.min.apply(Math, values);
        }

        return null;
      }

      function buildRangeScanUrl(box) {
        var parts = getPriceInputs(box);
        var url = getCurrentUrl();

        if (parts) {
          url.searchParams.delete(parts.minInput.name);
          url.searchParams.delete(parts.maxInput.name);
        }

        url.searchParams.delete('page');
        url.searchParams.delete('section_id');
        url.searchParams.delete('sort_by');
        return url;
      }

      function fetchHtml(url, signal) {
        return fetch(url, {
          method: 'GET',
          credentials: 'same-origin',
          signal: signal,
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        }).then(function (response) {
          if (!response.ok) throw new Error('Request failed');
          return response.text();
        });
      }

      function getCollectionEdgePrice(sourceUrl, signal, sortBy) {
        var sortedUrl = new URL(sourceUrl.toString());
        sortedUrl.searchParams.set('sort_by', sortBy);
        sortedUrl.searchParams.delete('page');

        return fetchHtml(sortedUrl.toString(), signal).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var cards = getProductCards(getProductRoot(doc));

          for (var i = 0; i < cards.length; i += 1) {
            var price = getPriceFromCard(cards[i]);
            if (price !== null) return price;
          }

          return null;
        });
      }

      function getLowestCollectionPrice(sourceUrl, signal) {
        return getCollectionEdgePrice(sourceUrl, signal, 'price-ascending');
      }

      function getHighestCollectionPrice(sourceUrl, signal) {
        return getCollectionEdgePrice(sourceUrl, signal, 'price-descending');
      }

      function getRenderedShopifyUpperBound(box) {
        var parts = getPriceInputs(box);
        if (!parts) return 0;
        if (box.dataset.vskloPriceFallback === 'true') return 0;

        return cleanNumber(
          parts.maxRange.getAttribute('max') ||
            parts.maxInput.getAttribute('max') ||
            parts.maxInput.getAttribute('placeholder') ||
            parts.maxInput.value ||
            0
        );
      }

      function scanFullPriceRange(box) {
        var parts = getPriceInputs(box);
        if (!parts) return;

        var sourceUrl = buildRangeScanUrl(box);
        var cacheKey = sourceUrl.toString();
        var renderedUpper = getRenderedShopifyUpperBound(box);
        var preserveSelection = touchedPriceBoxes.has(box);

        if (fullRangeCache.has(cacheKey)) {
          var cached = fullRangeCache.get(cacheKey);
          setPriceBounds(box, cached.min, cached.max, preserveSelection);
          return;
        }

        if (fullRangeController) fullRangeController.abort();
        fullRangeController = new AbortController();

        var requestId = ++fullRangeRequestId;

        var boundsPromise = renderedUpper > 0
          ? getLowestCollectionPrice(sourceUrl, fullRangeController.signal).then(function (minimum) {
              return { minimum: minimum, maximum: renderedUpper };
            })
          : Promise.all([
              getLowestCollectionPrice(sourceUrl, fullRangeController.signal),
              getHighestCollectionPrice(sourceUrl, fullRangeController.signal)
            ]).then(function (values) {
              return { minimum: values[0], maximum: values[1] };
            });

        boundsPromise
          .then(function (values) {
            if (requestId !== fullRangeRequestId) return;

            var min = isFinite(values.minimum) && values.minimum > 0 ? Math.round(values.minimum) : 0;
            var max = isFinite(values.maximum) && values.maximum > 0 ? Math.round(values.maximum) : renderedUpper;

            if (!isFinite(max) || max <= 0) return;
            if (min >= max) min = 0;

            var range = { min: min, max: max };
            fullRangeCache.set(cacheKey, range);

            var currentBox = box && box.isConnected
              ? box
              : document.querySelector('#CollectionSidebar .vsklo-price-filter');

            if (currentBox) {
              setPriceBounds(
                currentBox,
                range.min,
                range.max,
                touchedPriceBoxes.has(currentBox)
              );
              currentBox.classList.add('is-vsklo-price-ready');
            }
          })
          .catch(function (error) {
            if (error && error.name === 'AbortError') return;
            console.warn('VSKLO price lower bound scan skipped:', error);
          });
      }

      function getTrackValue(box, clientX) {
        var parts = getPriceInputs(box);
        var track = box && box.querySelector('.drop-range');
        if (!parts || !track) return null;

        var rect = track.getBoundingClientRect();
        if (!rect.width) return null;

        var bounds = getBounds(parts);
        var ratio = clamp((clientX - rect.left) / rect.width, 0, 1);

        if (document.documentElement.dir === 'rtl') ratio = 1 - ratio;

        return Math.round(bounds.lower + ratio * (bounds.upper - bounds.lower));
      }

      function chooseTrackThumb(parts, value) {
        var min = cleanNumber(parts.minRange.value);
        var max = cleanNumber(parts.maxRange.value);
        var minDistance = Math.abs(value - min);
        var maxDistance = Math.abs(value - max);

        if (minDistance === maxDistance) {
          return value <= (min + max) / 2 ? 'min' : 'max';
        }

        return minDistance < maxDistance ? 'min' : 'max';
      }

      function applyTrackValue(box, owner, value) {
        var parts = getPriceInputs(box);
        if (!parts || value === null) return;

        markPriceTouched(box);

        if (owner === 'min') {
          parts.minRange.value = String(value);
          updatePriceView(box, 'min');
        } else {
          parts.maxRange.value = String(value);
          updatePriceView(box, 'max');
        }
      }

      function beginTrackDrag(box, event) {
        var parts = getPriceInputs(box);
        if (!parts) return false;

        var value = getTrackValue(box, event.clientX);
        if (value === null) return false;

        var owner = chooseTrackThumb(parts, value);
        activeTrackDrag = {
          box: box,
          owner: owner,
          pointerId: event.pointerId,
        };

        applyTrackValue(box, owner, value);
        return true;
      }

      function moveTrackDrag(event) {
        if (!activeTrackDrag) return false;
        if (
          activeTrackDrag.pointerId !== undefined &&
          event.pointerId !== undefined &&
          event.pointerId !== activeTrackDrag.pointerId
        ) {
          return false;
        }

        var value = getTrackValue(activeTrackDrag.box, event.clientX);
        applyTrackValue(activeTrackDrag.box, activeTrackDrag.owner, value);
        return true;
      }

      function finishTrackDrag(event) {
        if (!activeTrackDrag) return false;

        var box = activeTrackDrag.box;
        if (
          activeTrackDrag.pointerId !== undefined &&
          event.pointerId !== undefined &&
          event.pointerId !== activeTrackDrag.pointerId
        ) {
          return false;
        }

        moveTrackDrag(event);
        activeTrackDrag = null;
        schedulePriceApply(box);
        return true;
      }

      function refreshAll(root) {
        root = root || document;

        sortFacetValuesByPopularity(root);
        forceDefaultOpenFilters(root);

        root.querySelectorAll('#CollectionSidebar .vsklo-price-filter').forEach(function (box) {
          box.setAttribute('data-vsklo-price-controller', 'v8');
          updatePriceView(box, 'init');

          if (box.dataset.vskloPriceFallback === 'true') {
            setTimeout(function () {
              scanFullPriceRange(box);
            }, 0);
            return;
          }

          var renderedUpper = getRenderedShopifyUpperBound(box);
          if (renderedUpper > 0) {
            setPriceBounds(box, 0, renderedUpper, touchedPriceBoxes.has(box));
            box.classList.add('is-vsklo-price-ready');
          }
        });

        applySavedClosedStates(root);
        syncFacetAccordionA11y(root);
      }

      function replaceInnerElement(selector, doc) {
        var oldEl = document.querySelector(selector);
        var newEl = doc.querySelector(selector);
        if (oldEl && newEl) oldEl.innerHTML = newEl.innerHTML;
      }

      function replaceOuterElement(selector, doc) {
        var oldEl = document.querySelector(selector);
        var newEl = doc.querySelector(selector);
        if (oldEl && newEl) oldEl.replaceWith(newEl.cloneNode(true));
      }

      // Merge AJAX facet options by stable value. Replacing the entire
      // .filter-blocks tree on each selection destroys touch targets between
      // pointerdown and click, steals keyboard focus and makes mobile lag.
      // The portal/dialog, accordions, and existing option nodes stay mounted.
      function syncFacetAttributes(live, fresh) {
        if (!live || !fresh) return;
        Array.from(live.attributes).forEach(function (attribute) {
          if (!fresh.hasAttribute(attribute.name)) live.removeAttribute(attribute.name);
        });
        Array.from(fresh.attributes).forEach(function (attribute) {
          if (live.getAttribute(attribute.name) !== attribute.value) {
            live.setAttribute(attribute.name, attribute.value);
          }
        });
      }

      function reconcileFacetList(liveList, freshList) {
        var existing = new Map();
        Array.from(liveList.children).forEach(function (li) {
          var key = li.getAttribute('data-vsklo-filter-value');
          if (key !== null) existing.set(key, li);
        });
        var retained = new Set();
        var freshItems = Array.from(freshList.children);
        if (freshItems.some(function (li) {
          return li.getAttribute('data-vsklo-filter-value') === null;
        })) return false;

        freshItems.forEach(function (freshLi, index) {
          var key = freshLi.getAttribute('data-vsklo-filter-value');
          var li = existing.get(key);
          if (!li) {
            li = freshLi.cloneNode(true);
          } else {
            syncFacetAttributes(li, freshLi);
            var liveChoice = li.querySelector('filter-item');
            var freshChoice = freshLi.querySelector('filter-item');
            if (liveChoice && freshChoice) {
              syncFacetAttributes(liveChoice, freshChoice);
              ['.checkbox', '.tooltip'].forEach(function (selector) {
                var a = liveChoice.querySelector(selector);
                var b = freshChoice.querySelector(selector);
                if (a && b && a.className !== b.className) a.className = b.className;
              });
              // Counts in the original Liquid are text nodes after the
              // translated label; update text only, without replacing the hit area.
              var liveText = Array.from(liveChoice.childNodes).filter(function (node) {
                return node.nodeType === 3;
              });
              var freshText = Array.from(freshChoice.childNodes).filter(function (node) {
                return node.nodeType === 3;
              });
              if (liveText.length === freshText.length) {
                freshText.forEach(function (node, textIndex) {
                  if (/\(\s*\d+\s*\)\s*$/.test(node.textContent) &&
                      liveText[textIndex].textContent !== node.textContent) {
                    liveText[textIndex].textContent = node.textContent;
                  }
                });
              }
            }
          }
          retained.add(li);
          if (liveList.children[index] !== li) {
            liveList.insertBefore(li, liveList.children[index] || null);
          }
        });
        Array.from(liveList.children).forEach(function (li) {
          if (!retained.has(li)) li.remove();
        });
        return true;
      }

      function reconcileFilterBlocks(liveBlocks, freshBlocks) {
        var liveRows = Array.from(liveBlocks.children);
        var freshRows = Array.from(freshBlocks.children);
        if (liveRows.length !== freshRows.length) return false;

        // Validate group identity before making any changes, so a changed
        // Shopify filter schema can use the existing full-content fallback.
        for (var i = 0; i < liveRows.length; i++) {
          var a = liveRows[i].querySelector('collapsible-block');
          var b = freshRows[i].querySelector('collapsible-block');
          if (!!a !== !!b || (a && getBlockKey(a) !== getBlockKey(b))) return false;
          if (a && a.querySelectorAll('ul.items').length !== b.querySelectorAll('ul.items').length) {
            return false;
          }
        }

        for (var j = 0; j < liveRows.length; j++) {
          var liveRow = liveRows[j];
          var freshRow = freshRows[j];
          var oldReset = liveRow.querySelector('facet-clear-all');
          var newReset = freshRow.querySelector('facet-clear-all');
          if (oldReset && newReset) syncFacetAttributes(oldReset, newReset);

          var current = liveRow.querySelector('collapsible-block');
          var incoming = freshRow.querySelector('collapsible-block');
          if (!current || !incoming) continue;

          var oldLists = Array.from(current.querySelectorAll('ul.items'));
          var newLists = Array.from(incoming.querySelectorAll('ul.items'));
          for (var k = 0; k < oldLists.length; k++) {
            if (!reconcileFacetList(oldLists[k], newLists[k])) return false;
          }

          // Price inputs stay in place during a drag or keyboard entry. Only
          // the dynamic bounds of the returned Shopify facet are refreshed.
          ['.min-price-range', '.max-price-range', '.range-slider-min', '.range-slider-max']
            .forEach(function (selector) {
              var oldInput = current.querySelector(selector);
              var newInput = incoming.querySelector(selector);
              if (!oldInput || !newInput) return;
              ['min', 'max', 'step'].forEach(function (name) {
                var next = newInput.getAttribute(name);
                if (next !== null && oldInput.getAttribute(name) !== next) {
                  oldInput.setAttribute(name, next);
                }
              });
              if (document.activeElement !== oldInput && !activeTrackDrag) {
                oldInput.value = newInput.value;
              }
            });

          var oldTotal = current.querySelector('.total-filter-select');
          var newTotal = incoming.querySelector('.total-filter-select');
          if (oldTotal && newTotal) {
            var oldCount = oldTotal.querySelector('.total_filter');
            var newCount = newTotal.querySelector('.total_filter');
            if (oldCount && newCount) oldCount.textContent = newCount.textContent;
            var oldClear = oldTotal.querySelector('filter-item[data-vsklo-clear-param]');
            var newClear = newTotal.querySelector('filter-item[data-vsklo-clear-param]');
            if (oldClear && newClear) syncFacetAttributes(oldClear, newClear);
          } else if (oldTotal && !newTotal) {
            oldTotal.remove();
          } else if (!oldTotal && newTotal && oldLists.length) {
            oldLists[0].parentNode.insertBefore(newTotal.cloneNode(true), oldLists[0]);
          }
        }
        return true;
      }

      function replaceFromHtml(html, url, push) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // Shopify's option ordering can differ from our curated popularity order.
        // Sort only the detached response so a stable live list is not moved twice.
        sortFacetValuesByPopularity(doc);
        var currentGrid = document.querySelector('#productgridcontainer');
        var newGrid = doc.querySelector('#productgridcontainer');
        var currentSidebar = document.querySelector('#CollectionSidebar');
        var sidebarWasOpen = !!(currentSidebar && currentSidebar.classList.contains('open'));
        var currentScrollPane = currentSidebar && currentSidebar.querySelector('.collection-sidebar');
        var sidebarScrollTop = currentScrollPane ? currentScrollPane.scrollTop : (currentSidebar ? currentSidebar.scrollTop : 0);
        var sidebarInsideGrid = !!(currentGrid && currentSidebar && currentGrid.contains(currentSidebar));

        var freshSidebar = doc.querySelector('#CollectionSidebar');
        var liveBlocks = currentSidebar && currentSidebar.querySelector('.filter-blocks');
        var freshBlocks = freshSidebar && freshSidebar.querySelector('.filter-blocks');
        // A live mobile drawer is a persistent dialog, NOT a piece of the AJAX
        // result. Replacing its outer node removes the open class, replays the
        // slide-in animation, loses focus, and makes each checkbox look as if
        // it closed/reopened the filter. Keep that same DOM node and shell.
        var keepDialogMounted = !!(sidebarWasOpen && currentSidebar.isConnected &&
          !sidebarInsideGrid && liveBlocks && freshBlocks);
        var accordionStates = keepDialogMounted
          ? Array.from(liveBlocks.querySelectorAll('collapsible-block')).map(function (block) {
              var content = block.querySelector('.collapsible-content');
              return {
                key: getBlockKey(block),
                open: block.classList.contains('active') &&
                  (!content || getComputedStyle(content).display !== 'none'),
                scroll: Array.from(block.querySelectorAll('ul.items')).map(function (list) {
                  return list.scrollTop;
                })
              };
            })
          : [];

        if (currentGrid && newGrid) {
          currentGrid.innerHTML = newGrid.innerHTML;
          // A horizontal mobile collection renders its sidebar INSIDE the
          // replaced grid. Its original portal anchor was just removed and
          // Shopify's response inserted a duplicate #CollectionSidebar.
          // Install a new anchor, discard the duplicate and keep the open
          // dialog mounted under body until the customer explicitly closes it.
          var embeddedSidebar = currentGrid.querySelector('#CollectionSidebar');
          if (sidebarWasOpen && currentSidebar && currentSidebar.parentNode === document.body &&
              embeddedSidebar && embeddedSidebar !== currentSidebar &&
              typeof window.VSKLOReanchorCollectionFilter === 'function') {
            window.VSKLOReanchorCollectionFilter(embeddedSidebar);
          }
        }

        if (keepDialogMounted) {
          // Only the facet content changes: leave the portal, close control,
          // backdrop, focus owner and CSS transition untouched.
          if (!reconcileFilterBlocks(liveBlocks, freshBlocks)) {
            // A market/filter schema change is the only case requiring a full
            // subtree replacement. The stable drawer itself still never closes.
            liveBlocks.innerHTML = freshBlocks.innerHTML;
          }
        } else if (!sidebarInsideGrid || !currentGrid || !newGrid) {
          replaceOuterElement('#CollectionSidebar', doc);
        }

        var updatedSidebar = document.getElementById('CollectionSidebar');
        if (!keepDialogMounted) {
          if (typeof window.VSKLOSetCollectionFiltersOpen === 'function') {
            window.VSKLOSetCollectionFiltersOpen(sidebarWasOpen && !!updatedSidebar, { preserveScroll: true });
          } else if (!updatedSidebar || !sidebarWasOpen) {
            document.documentElement.classList.remove('open-sidebar');
            window.VSKLOOverlayState?.release?.('collection-sidebar');
            window.VSKLOCleanupSharedDrawerShell?.();
          } else {
            updatedSidebar.classList.add('open');
          }
        }
        if (updatedSidebar && sidebarWasOpen) {
          var updatedScrollPane = updatedSidebar.querySelector('.collection-sidebar') || updatedSidebar;
          updatedScrollPane.scrollTop = sidebarScrollTop;
        }

        if (url && push !== false) {
          window.history.pushState({ vskloAjaxFilter: true }, '', url);
        }

        refreshAll(document);

        if (keepDialogMounted) {
          // Remember *user-expanded* sections too, not only explicitly closed
          // defaults. This prevents the current accordion from collapsing on
          // each selection while Shopify refreshes counts and disabled values.
          var afterBlocks = Array.from(liveBlocks.querySelectorAll('collapsible-block'));
          accordionStates.forEach(function (state, index) {
            var block = afterBlocks[index];
            if (!block || getBlockKey(block) !== state.key) {
              block = afterBlocks.find(function (candidate) {
                return getBlockKey(candidate) === state.key;
              });
            }
            if (!block) return;
            setBlockState(block, state.open, false);
            Array.from(block.querySelectorAll('ul.items')).forEach(function (list, listIndex) {
              list.scrollTop = state.scroll[listIndex] || 0;
            });
          });
          // The dialog stays visibly open across every AJAX result. Only the
          // existing explicit close, Apply, Escape and scrim may dismiss it.
        }

        var updatedScope =
          document.querySelector('#productgridcontainer') ||
          document.querySelector('#product-grid') ||
          document;

        document.dispatchEvent(new CustomEvent('vsklo:collection-filtered', {
          detail: { scope: updatedScope }
        }));
        document.dispatchEvent(new CustomEvent('vsklo:content-updated', {
          detail: { scope: updatedScope, source: 'collection-filter' }
        }));
        // The scoped content-updated event above owns product-card hydration.
        // Broadcasting a global resize reinitialized every Swiper on each
        // facet click and caused large visible interaction delays.
      }

      function normalizeManagedUrl(url) {
        var normalized = new URL(url.toString());
        normalized.searchParams.delete('page');
        normalized.searchParams.delete('section_id');
        return normalized;
      }

      function sameManagedUrl(a, b) {
        try {
          return normalizeManagedUrl(new URL(a, window.location.origin)).toString() ===
            normalizeManagedUrl(new URL(b, window.location.origin)).toString();
        } catch (error) {
          return String(a || '') === String(b || '');
        }
      }

      function getParamValues(url, param) {
        var values = [];
        url.searchParams.getAll(param).forEach(function (entry) {
          String(entry || '').split(',').forEach(function (value) {
            value = value.trim();
            if (value && values.indexOf(value) === -1) values.push(value);
          });
        });
        return values;
      }

      function writeParamValues(url, param, values) {
        url.searchParams.delete(param);
        values.forEach(function (value) {
          url.searchParams.append(param, value);
        });
        url.searchParams.delete('page');
      }

      function setInstantVisualState(el, active) {
        if (!el) return;
        var li = el.closest('li');
        var checkbox = el.querySelector('.checkbox');
        var tooltip = el.querySelector('.tooltip');

        if (li) li.classList.toggle('current-filter', !!active);
        if (checkbox) checkbox.classList.toggle('checked', !!active);
        if (tooltip) tooltip.classList.toggle('current-filter', !!active);

        if (el.hasAttribute('data-vsklo-filter-active')) {
          el.setAttribute('data-vsklo-filter-active', active ? 'true' : 'false');
        }
        if (el.hasAttribute('aria-checked')) {
          el.setAttribute('aria-checked', active ? 'true' : 'false');
        }
      }

      function toggleDesiredFacet(el) {
        var param = el.getAttribute('data-vsklo-filter-param');
        var value = el.getAttribute('data-vsklo-filter-value');
        if (!param || value === null) return false;

        var values = getParamValues(desiredUrl, param);
        var index = values.indexOf(value);
        var nextActive = index === -1;

        if (nextActive) values.push(value);
        else values.splice(index, 1);

        writeParamValues(desiredUrl, param, values);
        setInstantVisualState(el, nextActive);
        return true;
      }

      function clearDesiredParam(param) {
        if (!param) return false;
        desiredUrl.searchParams.delete(param);
        desiredUrl.searchParams.delete('page');
        return true;
      }

      function clearDesiredPrice() {
        var box = document.querySelector('#CollectionSidebar .vsklo-price-filter');
        var parts = getPriceInputs(box);

        if (parts) {
          desiredUrl.searchParams.delete(parts.minInput.name);
          desiredUrl.searchParams.delete(parts.maxInput.name);
        } else {
          desiredUrl.searchParams.delete('filter.v.price.gte');
          desiredUrl.searchParams.delete('filter.v.price.lte');
        }

        desiredUrl.searchParams.delete('page');
      }

      function copyManagedFilterParams(fromUrl, toUrl) {
        var names = [];
        Array.from(toUrl.searchParams.keys()).forEach(function (name) {
          if (name.indexOf('filter.') === 0 && names.indexOf(name) === -1) names.push(name);
        });
        names.forEach(function (name) {
          toUrl.searchParams.delete(name);
        });

        fromUrl.searchParams.forEach(function (value, name) {
          if (name.indexOf('filter.') === 0) toUrl.searchParams.append(name, value);
        });

        if (fromUrl.searchParams.has('sort_by')) {
          toUrl.searchParams.set('sort_by', fromUrl.searchParams.get('sort_by'));
        }
        toUrl.searchParams.delete('page');
      }

      function setDesiredFromDirectHref(href) {
        if (!href) return false;
        var direct = new URL(href, window.location.origin);
        copyManagedFilterParams(desiredUrl, direct);
        desiredUrl = direct;
        return true;
      }

      function setDesiredClearAll(href) {
        desiredUrl = new URL(href || window.location.pathname, window.location.origin);
        desiredUrl.searchParams.delete('page');
      }

      function queueDesiredNavigation(push, delay) {
        desiredUrl = normalizeManagedUrl(desiredUrl);
        var finalUrl = desiredUrl.toString();
        var version = ++desiredVersion;
        var wait = typeof delay === 'number' ? Math.max(0, delay) : 110;

        clearTimeout(ajaxTimer);
        ajaxTimer = null;

        if (currentController) {
          currentController.abort();
          currentController = null;
        }

        if (sameManagedUrl(finalUrl, confirmedUrl)) {
          document.documentElement.classList.remove('vsklo-filter-loading');
          return;
        }

        var runRequest = function () {
          ajaxTimer = null;
          var controller = new AbortController();
          currentController = controller;
          document.documentElement.classList.add('vsklo-filter-loading');

          // Fetch only the owning Shopify collection section. A full page can
          // carry hundreds of KB of unrelated Liquid, headers and sliders.
          // If a nonstandard collection template cannot render the section,
          // safely fall back to the same filtered full-page URL.
          var owner = document.querySelector('.sec__collection-main[data-section-id]');
          var sectionId = owner && owner.getAttribute('data-section-id');
          var requestUrl = new URL(finalUrl);
          if (sectionId) requestUrl.searchParams.set('section_id', sectionId);

          function loadSection(url) {
            return fetch(url, {
              method: 'GET',
              credentials: 'same-origin',
              signal: controller.signal,
              headers: { 'X-Requested-With': 'XMLHttpRequest' },
            }).then(function (response) {
              if (!response.ok) throw new Error('Filter AJAX failed: ' + response.status);
              return response.text();
            });
          }

          loadSection(requestUrl.toString())
            .then(function (html) {
              if (version !== desiredVersion || currentController !== controller) return null;
              if (!sectionId) return html;
              var doc = new DOMParser().parseFromString(html, 'text/html');
              if (doc.querySelector('#productgridcontainer') &&
                  doc.querySelector('#CollectionSidebar')) return html;
              return loadSection(finalUrl);
            })
            .then(function (html) {
              if (!html || version !== desiredVersion || currentController !== controller) return;
              replaceFromHtml(html, finalUrl, push);
              confirmedUrl = finalUrl;
              desiredUrl = new URL(finalUrl);
            })
            .catch(function (error) {
              if (error && error.name === 'AbortError') return;
              if (version !== desiredVersion) return;
              console.error('[VSKLO] Collection filter request failed:', error);
              window.location.href = finalUrl;
            })
            .finally(function () {
              if (currentController === controller) currentController = null;
              if (version === desiredVersion && !ajaxTimer) {
                document.documentElement.classList.remove('vsklo-filter-loading');
              }
            });
        };

        if (wait > 0) ajaxTimer = setTimeout(runRequest, wait);
        else runRequest();
      }

      function buildPriceUrl(box) {
        var parts = getPriceInputs(box);
        if (!parts) return null;
        var minName = parts.minInput.name;
        var maxName = parts.maxInput.name;
        if (!minName || !maxName) return null;

        var min = cleanNumber(parts.minInput.value);
        var max = cleanNumber(parts.maxInput.value);
        var lower = cleanNumber(parts.minRange.min || parts.minInput.min || 0);
        var upper = cleanNumber(parts.maxRange.max || parts.maxInput.max || max);
        var url = new URL(desiredUrl.toString());

        if (min > lower) url.searchParams.set(minName, formatPlain(min));
        else url.searchParams.delete(minName);

        if (upper > 0 && max < upper) url.searchParams.set(maxName, formatPlain(max));
        else url.searchParams.delete(maxName);

        url.searchParams.delete('page');
        return url.toString();
      }

      function schedulePriceApply(box) {
        clearTimeout(priceTimer);
        priceTimer = setTimeout(function () {
          var url = buildPriceUrl(box);
          if (!url) return;
          desiredUrl = new URL(url, window.location.origin);
          queueDesiredNavigation(true, 0);
        }, 90);
      }

      document.addEventListener(
        'click',
        function (event) {
          var heading = event.target.closest('#CollectionSidebar .collapsible-heading');
          if (!heading) return;
          if (event.target.closest('input, button, a, filter-item, facet-clear-all, facet-apply-canvas')) return;
          var block = heading.closest('collapsible-block');
          if (!block) return;
          var content = block.querySelector('.collapsible-content');
          if (!content) return;
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          var isOpen = block.classList.contains('active') && getComputedStyle(content).display !== 'none';
          setBlockState(block, !isOpen, true);
        },
        true
      );

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        var heading = event.target.closest('#CollectionSidebar .collapsible-heading[role="button"]');
        if (!heading || event.target !== heading) return;
        event.preventDefault();
        heading.click();
      }, true);

      document.addEventListener(
        'click',
        function (event) {
          var sortItem = event.target.closest('filter-sort');
          if (sortItem) {
            var sortValue = sortItem.getAttribute('value');
            if (!sortValue) return;
            event.preventDefault();
            event.stopPropagation();
            if (event.stopImmediatePropagation) event.stopImmediatePropagation();
            desiredUrl.searchParams.set('sort_by', sortValue);
            desiredUrl.searchParams.delete('page');
            var select = sortItem.closest('.select-custom');
            if (select) select.classList.remove('active');
            queueDesiredNavigation(true, 0);
            return;
          }

          var filterLink = event.target.closest(
            'filter-item[data-vsklo-filter-param], filter-item[data-vsklo-clear-param], filter-item[data-vsklo-clear-price], filter-item[data-vsklo-clear-all], facet-clear-all[data-vsklo-clear-all]'
          );

          if (filterLink) {
            event.preventDefault();
            event.stopPropagation();
            if (event.stopImmediatePropagation) event.stopImmediatePropagation();

            if (filterLink.hasAttribute('data-vsklo-filter-param')) {
              toggleDesiredFacet(filterLink);
              // Checkbox feedback is immediate. Coalesce a quick group of
              // selections so users can tap repeatedly without replacing the
              // entire facet DOM after every touch.
              queueDesiredNavigation(true, window.matchMedia('(max-width: 1024px)').matches ? 65 : 45);
              return;
            }

            if (filterLink.hasAttribute('data-vsklo-clear-param')) {
              clearDesiredParam(filterLink.getAttribute('data-vsklo-clear-param'));
              queueDesiredNavigation(true, 0);
              return;
            }

            if (filterLink.hasAttribute('data-vsklo-clear-price')) {
              clearDesiredPrice();
              queueDesiredNavigation(true, 0);
              return;
            }

            if (filterLink.hasAttribute('data-vsklo-clear-all')) {
              setDesiredClearAll(filterLink.getAttribute('data-href'));
              queueDesiredNavigation(true, 0);
              return;
            }
          }

          var directFilterLink = event.target.closest('.filter-current filter-item[data-href]');
          if (!directFilterLink) return;

          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();

          if (setDesiredFromDirectHref(directFilterLink.getAttribute('data-href'))) {
            queueDesiredNavigation(true, 0);
          }
        },
        true
      );

      // Native keyboard activation for custom Shopify facet elements.
      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        var choice = event.target.closest(
          '#CollectionSidebar filter-item[data-vsklo-filter-param], #CollectionSidebar filter-item[data-vsklo-clear-param], #CollectionSidebar filter-item[data-vsklo-clear-price], #CollectionSidebar facet-clear-all[data-vsklo-clear-all], .filter-current filter-item[data-href]'
        );
        if (!choice) return;
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        choice.click();
      }, true);

      document.addEventListener(
        'pointerdown',
        function (event) {
          var track = event.target.closest('#CollectionSidebar .vsklo-price-filter .drop-range');
          if (!track) return;

          // Native thumb dragging remains native. The custom track handler owns
          // clicks/drags that start anywhere else on the rail.
          if (event.target.closest('.range-slider')) return;

          var box = track.closest('.vsklo-price-filter');
          if (!box) return;

          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();

          markPriceTouched(box);
          beginTrackDrag(box, event);
        },
        true
      );

      document.addEventListener(
        'pointermove',
        function (event) {
          if (!activeTrackDrag) return;
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          moveTrackDrag(event);
        },
        true
      );

      ['pointerup', 'pointercancel'].forEach(function (eventName) {
        document.addEventListener(
          eventName,
          function (event) {
            if (!activeTrackDrag) return;
            event.preventDefault();
            event.stopPropagation();
            if (event.stopImmediatePropagation) event.stopImmediatePropagation();
            finishTrackDrag(event);
          },
          true
        );
      });

      document.addEventListener(
        'input',
        function (event) {
          var target = event.target;
          var box = getPriceBox(target);
          if (!box) return;

          var isMinRange = target.matches('#CollectionSidebar .range-slider-min');
          var isMaxRange = target.matches('#CollectionSidebar .range-slider-max');
          var isTextPrice = target.matches(
            '#CollectionSidebar .min-price-range, #CollectionSidebar .max-price-range'
          );

          if (!isMinRange && !isMaxRange && !isTextPrice) return;

          // V7 is the sole owner. Prevent collection.js from running a second
          // price controller on the same inputs.
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();

          markPriceTouched(box);

          if (isMinRange) updatePriceView(box, 'min');
          else if (isMaxRange) updatePriceView(box, 'max');
          // Text fields intentionally remain untouched while typing.
        },
        true
      );

      document.addEventListener(
        'change',
        function (event) {
          var target = event.target;
          var box = getPriceBox(target);
          if (!box) return;

          var source = null;
          if (target.matches('#CollectionSidebar .range-slider-min')) source = 'min';
          else if (target.matches('#CollectionSidebar .range-slider-max')) source = 'max';
          else if (target.matches('#CollectionSidebar .min-price-range')) source = 'text-min';
          else if (target.matches('#CollectionSidebar .max-price-range')) source = 'text-max';

          if (!source) return;

          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();

          markPriceTouched(box);
          updatePriceView(box, source);
          schedulePriceApply(box);
        },
        true
      );

      document.addEventListener(
        'keydown',
        function (event) {
          var target = event.target;
          if (
            event.key !== 'Enter' ||
            !target.matches('#CollectionSidebar .min-price-range, #CollectionSidebar .max-price-range')
          ) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          target.blur();
        },
        true
      );

      document.addEventListener(
        'focusin',
        function (event) {
          var target = event.target;
          var box = getPriceBox(target);
          if (!box) return;

          var parts = getPriceInputs(box);
          if (!parts) return;

          if (target.matches('#CollectionSidebar .range-slider-min')) setActiveThumb(parts, 'min');
          if (target.matches('#CollectionSidebar .range-slider-max')) setActiveThumb(parts, 'max');
        },
        true
      );

      window.addEventListener('popstate', function () {
        clearTimeout(ajaxTimer);
        ajaxTimer = null;
        clearTimeout(priceTimer);

        if (currentController) {
          currentController.abort();
          currentController = null;
        }

        desiredUrl = normalizeManagedUrl(new URL(window.location.href));
        confirmedUrl = '';
        queueDesiredNavigation(false, 0);
      });

      function initFilterStateOnce() {
        refreshAll(document);
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initFilterStateOnce, { once: true });
      } else {
        initFilterStateOnce();
      }
    })();

window.VSKLO_PRODUCT_TYPE_FILTER_FORCE_OPEN =
    window.VSKLO_PRODUCT_TYPE_FILTER_FORCE_OPEN ||
    (function () {
      function normalize(text) {
        return String(text || '')
          .trim()
          .toLowerCase();
      }
      function isProductType(text) {
        var value = normalize(text);
        return (
          value === 'тип товару' || value === 'тип продукту' || value === 'product type' || value === 'type product'
        );
      }
      function openProductType() {
        document.querySelectorAll('.vsklo-filter-accordion, collapsible-block').forEach(function (block) {
          var heading = block.querySelector('.collapsible-heading, summary, h3, h4');
          if (!heading || !isProductType(heading.textContent)) return;
          block.classList.add('active');
          var content = block.querySelector('.collapsible-content, .filter-content');
          if (content) content.style.display = '';
          var details = block.matches('details') ? block : block.querySelector('details');
          if (details) details.open = true;
        });
      }
      document.addEventListener('DOMContentLoaded', openProductType);
      window.addEventListener('load', openProductType);
      return true;
    })();
